// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Database Manager API
 * API to orchestra resources
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface V1ClusterMemberInfo
 */
export interface V1ClusterMemberInfo {
  /**
   *
   * @type {boolean}
   * @memberof V1ClusterMemberInfo
   */
  discoveryHealthy?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof V1ClusterMemberInfo
   */
  healthy?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof V1ClusterMemberInfo
   */
  inRaftGroup?: boolean;
  /**
   *
   * @type {string}
   * @memberof V1ClusterMemberInfo
   */
  leader?: string;
  /**
   *
   * @type {string}
   * @memberof V1ClusterMemberInfo
   */
  memberID?: string;
  /**
   *
   * @type {boolean}
   * @memberof V1ClusterMemberInfo
   */
  recentContactWithLeader?: boolean;
}

/**
 * Check if a given object implements the V1ClusterMemberInfo interface.
 */
export function instanceOfV1ClusterMemberInfo(
  value: object,
): value is V1ClusterMemberInfo {
  return true;
}

export function V1ClusterMemberInfoFromJSON(json: any): V1ClusterMemberInfo {
  return V1ClusterMemberInfoFromJSONTyped(json, false);
}

export function V1ClusterMemberInfoFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): V1ClusterMemberInfo {
  if (json == null) {
    return json;
  }
  return {
    discoveryHealthy:
      json['DiscoveryHealthy'] == null ? undefined : json['DiscoveryHealthy'],
    healthy: json['Healthy'] == null ? undefined : json['Healthy'],
    inRaftGroup: json['InRaftGroup'] == null ? undefined : json['InRaftGroup'],
    leader: json['Leader'] == null ? undefined : json['Leader'],
    memberID: json['MemberID'] == null ? undefined : json['MemberID'],
    recentContactWithLeader:
      json['RecentContactWithLeader'] == null
        ? undefined
        : json['RecentContactWithLeader'],
  };
}

export function V1ClusterMemberInfoToJSON(json: any): V1ClusterMemberInfo {
  return V1ClusterMemberInfoToJSONTyped(json, false);
}

export function V1ClusterMemberInfoToJSONTyped(
  value?: V1ClusterMemberInfo | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    DiscoveryHealthy: value['discoveryHealthy'],
    Healthy: value['healthy'],
    InRaftGroup: value['inRaftGroup'],
    Leader: value['leader'],
    MemberID: value['memberID'],
    RecentContactWithLeader: value['recentContactWithLeader'],
  };
}
